module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v(" Firmenübersicht ")])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "fill-height": ""
    }
  }, _vm._l((_vm.filteredFirmen), function(firma) {
    return _c('v-flex', {
      key: firma.id,
      attrs: {
        "xs12": "",
        "md6": "",
        "lg4": ""
      }
    }, [_c('single-firmen', {
      attrs: {
        "fa": firma
      },
      on: {
        "toDestroy": function($event) {
          _vm.onDestroy(firma.id)
        }
      }
    })], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56a5a717","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/firmen/showFirmen.vue
// module id = 326
// module chunks = 0